<div class="estimer">
  <p class="bold-xl">Combien vaut votre bien ?</p>
  <p>Obtenez une <strong>estimation rapide et gratuite</strong> du prix de vente :</p>
  <form [formGroup]="searchForm" class=" w-100">
    <div class="form-group">
      <div class="w-100">
        <div class="container-search-input w-100">
          <span class="close-search-result" *ngIf="searchedAddresses.length > 0"
            (click)="cancelSearchingAddress()">×</span>
          <input #locality type="search" class="form-control mb-3" id="locality" aria-label="Où se situe votre bien ?" placeholder="Où se situe votre bien ?"
            autocomplete="off" formControlName="locality" aria-describedby="localitiesHelp"
            [ngClass]="{ 'is-invalid': submitted && f.locality.errors }" />
          <div *ngIf="submitted && f.locality.errors" class="invalid-feedback">
            <div *ngIf="f.locality.errors.required">Champ obligatoire</div>
          </div>
        </div>
        <div *ngIf="searchedAddresses.length > 0" class="result-localities-container">
          <ul class="list-group list-group-result">
            <li *ngFor="let locality of searchedAddresses" class="list-group-item elem-result-item"
              (click)="chooseLocality(locality)">
              {{ locality.ville }}
            </li>
          </ul>
        </div>
      </div>
      <div class="btn-recherche-rapide">
        <app-modal-estimation-bien [locality]="choosedLocality" [requiredLocality]="true" (tryOpen)="submitFormSearch()"></app-modal-estimation-bien>
      </div>
    </div>
  </form>
</div>